
import {
  ArrowRight, Zap, BarChart3, CreditCard,
  Bell, Shield, CheckCircle2, Star, Sparkles, Target,
  TrendingUp, Award, Play, Mail,
  ShoppingBag, Package, Users, Tag,
  Heart, CheckCircle, XCircle, ChevronRight, Settings,
  Repeat, Percent, FileText, Layers, RefreshCw,
  Crown, Gem, Check
} from "lucide-react";

const iconMap = {
  ArrowRight, Zap, BarChart3, CreditCard,
  Bell, Shield, CheckCircle2, Star, Sparkles, Target,
  TrendingUp, Award, Play, Mail,
  ShoppingBag, Package, Users, Tag,
  Heart, CheckCircle, XCircle, ChevronRight, Settings,
  Repeat, Percent, FileText, Layers, RefreshCw,
  Crown, Gem, Check
};

/**
 * Resolves an icon name string to a Lucide React component element.
 * @param {string} name - Icon name matching lucide-react export
 * @param {object} props - Props to pass to the icon component (e.g. style)
 * @returns {JSX.Element|null}
 */
export const getIcon = (name, props = {}) => {
  const IconComponent = iconMap[name];
  if (!IconComponent) return null;
  return <IconComponent {...props} />;
};

export default iconMap;